import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { Constants } from 'src/app/models/constants';
import { environment } from 'src/environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  year: string;

  Constants = Constants;
  version: string;
  private destroyRef = inject(DestroyRef);

  constructor() {  }

  ngOnInit(): void {
    this.year = new Date().getFullYear().toString();
    this.version = environment.appVersion;
  }

}
